// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Logout Icon.
 * @param {IconProps} props - The IconProps for the LogoutIcon component.
 * @returns {ReactElement} The LogoutIcon component.
 */
export const LogoutIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon width='15' height='14' viewBox='0 0 15 14' color={color} {...rest}>
      <path
        id='Vector'
        d='M14.7253 7.66197C15.0916 7.29575 15.0916 6.70099 14.7253 6.33476L10.9751 2.58458C10.6089 2.21835 10.0142 2.21835 9.64793 2.58458C9.2817 2.95081 9.2817 3.54556 9.64793 3.91179L11.7984 6.06229H5.62528C5.10669 6.06229 4.68773 6.48125 4.68773 6.99983C4.68773 7.51841 5.10669 7.93738 5.62528 7.93738H11.7984L9.64793 10.0879C9.2817 10.4541 9.2817 11.0489 9.64793 11.4151C10.0142 11.7813 10.6089 11.7813 10.9751 11.4151L14.7253 7.6649V7.66197ZM4.68773 2.3121C5.20631 2.3121 5.62528 1.89314 5.62528 1.37456C5.62528 0.855977 5.20631 0.437012 4.68773 0.437012H2.81264C1.25983 0.437012 0 1.69684 0 3.24965V10.75C0 12.3028 1.25983 13.5627 2.81264 13.5627H4.68773C5.20631 13.5627 5.62528 13.1437 5.62528 12.6251C5.62528 12.1065 5.20631 11.6876 4.68773 11.6876H2.81264C2.29406 11.6876 1.87509 11.2686 1.87509 10.75V3.24965C1.87509 2.73107 2.29406 2.3121 2.81264 2.3121H4.68773Z'
        fill='#25CAD2'
      />
    </Icon>
  );
};
